import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * OAuth Callback Page
 * Handles redirect from Google OAuth and redirects to dashboard
 */
const AuthCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const success = searchParams.get('success');
    
    if (success === 'true') {
      // Clear service worker cache on successful login
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }
      // Hard redirect to dashboard (bypasses React Router, clears stale cache)
      window.location.href = "/dashboard";
    } else {
      // Error, redirect to home
      window.location.href = "/";
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#1A4D2E] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#4B5563]">Giriş yapılıyor...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
